export const NANGO_SETTINGS_PATH = '/settings/integrations/nango';
export const NANGO_INTEGRATION_SLUG = 'nango';
